import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import PresentationAttributeApi from '@/api/presentationAttribute'
import constant from '@/constant'

const _state = {
  presentationAttribute: {},
}

function setupColors(colors) {
  const COLORS_LENGTH = 30
  if (!colors || colors.length === 0) {
    return new Array(COLORS_LENGTH).fill('#6A1EBB')
  }

  const result = [...colors]
  const { length } = result
  for (let i = 0; i < COLORS_LENGTH; i++) {
    if (result[i] === undefined) {
      result[i] = result[i % length]
    }
  }
  return result
}

const mutations = {
  setPresentationAttribute(state, payload) {
    state.presentationAttribute = payload
  },
  updatePresentationAttribute(state, payload) {
    Vue.set(state.presentationAttribute, payload.attributeName, payload.attributeValue)
  },
}

const actions = {
  async fetchPresentationAttributes(_, presentationId) {
    return PresentationAttributeApi.getPresentationAttributes(presentationId)
  },

  async getPresentationAttributeAction({ dispatch, commit, rootGetters }, presentationId) {
    try {
      const resp = await dispatch('optimizeEditorLoadModule/getPresentationAttributesWithCacheAction', {
        presentationId,
        maxAgeInSeconds: rootGetters['optimizeEditorLoadModule/maxPresentationCacheTimeInSeconds'],
      }, { root: true })
      commit('setPresentationAttribute', resp.body)
      return resp.body
    } catch (error) {
      Sentry.captureMessage(new Error('Get Presentation Attribute Error'), {
        level: 'warning',
        extra: {
          presentationId,
          error,
        },
      })
      return {}
    }
  },

  async updatePresentationAttributeAction({ commit }, { presentationId, payload }) {
    commit('updatePresentationAttribute', payload)
    const resp = await PresentationAttributeApi.patchPresentationAttribute(presentationId, payload)
    return resp.body
  },
}

const _getters = {
  presentationColorPalette: (state) => {
    let colors = constant.colors2025
    if (state.presentationAttribute?.colorPalette?.colors) {
      colors = state.presentationAttribute.colorPalette.colors
    }
    return setupColors(colors)
  },
  presentationLighterColorPalette: (state) => {
    let lighterColors = constant.lighterColors2025
    if (state.presentationAttribute?.colorPalette?.lighterColors) {
      lighterColors = state.presentationAttribute.colorPalette.lighterColors
    }
    return setupColors(lighterColors)
  },

  presentationAttributeColorPalette: (state) => {
    return state.presentationAttribute.colorPalette || {}
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters: _getters,
}
